import React from 'react';
import { SystemText } from 'e4shared';
import { Link, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

import BlobImage from 'components/blobImage';
import Bullet from 'components/prism/bullet';
import ProgressBar from '../progressBar';

export const PathwayCard = ({ pathway }) => {
    const { prismMultiColumn } = useSelector(state => state.ui);

    return (
        <Link data-testid="pathway-item" to={`/pathway/${pathway.id}`} className="prism-content-box">
            {prismMultiColumn && (
                <div className="prism-banner">
                    {pathway.image ? (
                        <BlobImage src={pathway.image} folder="pathway_Image" noholder />
                    ) : (
                        <img src="/dist/img/defaults/pathway-default.jpg" />
                    )}
                </div>
            )}
            <div className="prism-content">
                <Bullet type="pathway" />
                <ProgressBar progress={pathway.progress} />
                <h3>{pathway.name}</h3>
                {pathway.description && <p className="truncate-4">{pathway.description}</p>}
                <button className="btn btn-primary mb10">
                    {pathway.progress ? SystemText('Welcome/Pathway/Resume') : SystemText('Welcome/Pathway/Start')}
                </button>
                <div className="split-col">
                    {pathway.completed ? (
                        <Bullet isDueDate value={pathway.due} />
                    ) : (
                        <Bullet isOpenDueDate value={pathway.due} />
                    )}
                    {pathway.duration > 0 && <Bullet isDuration value={pathway.duration / 60} />}
                </div>
            </div>
        </Link>
    );
};

export default withRouter(PathwayCard);
